// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-material-components/dist/vue-material-components.css
// module id = 426
// module chunks = 10